import React from "react";
import { SFHeroContainer, SFHeroSlide } from "@sf-core";

const LoadingHero = () => (
  <SFHeroContainer notLoading={false}>
    <SFHeroSlide loading/>
    <SFHeroSlide loading/>
    <SFHeroSlide loading/>
  </SFHeroContainer>
);

export default LoadingHero;
